/*
 * @Descripttion: 
 * @version: 
 * @Author: liuzihao
 * @Date: 20201-08-2 15:03:13
 * @LastEditors: wl
 * @LastEditTime: 2020-08-15 15:09:49
 */
import axios from '../axios'

// 绑定设备
export const bindwatch= (data) => {
    return axios({
        url: '/device/commons/binding',
        method: 'post',
        data,
        type:1
    })
}


//设备列表
export const bindlist= (params) => {
    return axios({
        url: '/device/commons/watchgt3',
        method: 'get',
        params,
        type:1
    })
}


export const warnbind= (data) => {
    return axios({
        url: '/device/commons/warnbind',
        method: 'post',
        data,
        type:1,
        
    })
}

//设备功能查询
export const powerfind= (params) => {
    return axios({
        url: '/device/commons/action',
        method: 'get',
        params,
        type:1
    })
}



// 人员查询
export const serchaperson = (data) => {
    return axios({
        url: '/admin/service/sys_person_info2',
        method: 'post',
        data,
        type:2
    })
}


// 手环预警
export const warning_log = (params) => {
    return axios({
        url: '/device/commons/warning_log',
        method: 'get',
        params,
        type:1
    })
}

//手环回显
export const warnbindDetail = (params) => {
    return axios({
        url: '/device/commons/warnbindDetail',
        method: 'get',
        params,
        type:1
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/bracelct.js